import { render, staticRenderFns } from "./ModalAssignProcess.vue?vue&type=template&id=58d50130&"
import script from "./ModalAssignProcess.vue?vue&type=script&lang=js&"
export * from "./ModalAssignProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d50130')) {
      api.createRecord('58d50130', component.options)
    } else {
      api.reload('58d50130', component.options)
    }
    module.hot.accept("./ModalAssignProcess.vue?vue&type=template&id=58d50130&", function () {
      api.rerender('58d50130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/massiveProcess/ModalAssignProcess.vue"
export default component.exports